import { getCityCenter } from './getCityCenter'
export default {
    mounted () {
        if (!window.TMap) {
            const script = document.createElement('script')
            script.src = 'https://map.qq.com/api/gljs?libraries=tools&v=1.exp&key=OYOBZ-IFFWP-RUDDH-LM5JW-XYFA7-R5FI4'
            script.onload = this.initMap
            document.head.appendChild(script)
        } else {
            this.initMap()
        }
    },
    methods: {
        initMap () {
            const city = this.$route.params.city || 'cd'
            const point = getCityCenter(city)
            const map = new window.TMap.Map('container', {
                zoom: 18,
                center: new window.TMap.LatLng(point[1], point[0])
            })
            window.map = map
        }
    }
}